import md5 from 'crypto-js/md5';

/**
 * Generate a Gravatar URL for the given email address
 * @param email - The email address to generate a Gravatar for
 * @param size - The size of the avatar (default: 80)
 * @param defaultImage - The default image to use if no Gravatar exists (default: 'mp' for mystery person)
 * @returns The Gravatar URL
 */
export function getGravatarUrl(email: string, size: number = 80, defaultImage: string = 'mp'): string {
  const trimmedEmail = email.trim().toLowerCase();
  const hash = md5(trimmedEmail).toString();
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=${defaultImage}`;
}

/**
 * Get initials from email if no name is available
 * @param email - The email address
 * @returns The initials (max 2 characters)
 */
export function getInitialsFromEmail(email: string): string {
  const localPart = email.split('@')[0];
  const parts = localPart.replace(/[._-]+/g, ' ').split(' ').filter(p => p.length > 0);
  
  if (parts.length >= 2) {
    // If multiple parts, use first letter of first two parts
    return (parts[0][0] + parts[1][0]).toUpperCase();
  } else if (parts.length === 1 && parts[0].length >= 2) {
    // If single part, use first two letters
    return parts[0].substring(0, 2).toUpperCase();
  } else {
    // Fallback to first letter of email
    return email[0].toUpperCase();
  }
}